import { DependencyList, EffectCallback, useCallback, useEffect, useMemo, useRef } from "react"

import { FunctionAny } from "../types"

export function useGranularCallback<T extends FunctionAny>(
  callback: T,
  primaryDeps: DependencyList,
  secondaryDeps: DependencyList = [],
): T {
  const ref = useRef<DependencyList>(undefined)

  if (!ref.current || !primaryDeps.every((primaryDep, index) => Object.is(primaryDep, ref.current?.[index]))) {
    ref.current = [...primaryDeps, ...secondaryDeps]
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(callback, ref.current)
}

export function useGranularEffect<T extends EffectCallback>(
  callback: T,
  primaryDeps: DependencyList,
  secondaryDeps: DependencyList = [],
): void {
  const ref = useRef<DependencyList>(undefined)

  if (!ref.current || !primaryDeps.every((primaryDep, index) => Object.is(primaryDep, ref.current?.[index]))) {
    ref.current = [...primaryDeps, ...secondaryDeps]
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(callback, ref.current)
}

export function useGranularMemo<T>(
  callback: () => T,
  primaryDeps: DependencyList,
  secondaryDeps: DependencyList = [],
): T {
  const ref = useRef<DependencyList>(undefined)

  if (!ref.current || !primaryDeps.every((primaryDep, index) => Object.is(primaryDep, ref.current?.[index]))) {
    ref.current = [...primaryDeps, ...secondaryDeps]
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(callback, ref.current)
}
